/* Titta · Producto pack — selector propio (reemplaza Fast Bundle) */
(function () {
  'use strict';

  function money(cents, fmt) {
    var v = (cents / 100);
    var s = v.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (fmt && fmt.indexOf('{{') > -1) return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, s);
    return '$' + s;
  }

  /* ---------- Galería ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-gal-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-gal-slide]');
    var thumbs = root.querySelectorAll('[data-gal-thumb]');
    var count = root.querySelector('[data-gal-count]');
    var current = 0;
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function setActive(i) {
      current = i;
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var at = thumbs[i];
      if (at && at.parentElement) {
        var p = at.parentElement;
        p.scrollTo({ left: at.offsetLeft - p.clientWidth / 2 + at.clientWidth / 2, behavior: 'smooth' });
      }
      slides.forEach(function (s, k) { var v = s.querySelector('video'); if (v && k !== i) v.pause(); });
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); }, 60);
    }, { passive: true });
    thumbs.forEach(function (th) { th.addEventListener('click', function () { go(+th.dataset.galThumb); }); });
    var prev = root.querySelector('[data-gal-prev]'), next = root.querySelector('[data-gal-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(current + 1);
      if (e.key === 'ArrowLeft') go(current - 1);
    });
  }

  /* ---------- Selector del pack ---------- */
  function initBuilder(root) {
    var jsonEl = root.querySelector('[data-builder-json]');
    if (!jsonEl) return;
    var cfg = JSON.parse(jsonEl.textContent);
    var N = cfg.packSize;
    var sKey = 'o' + cfg.sizeIndex, cKey = 'o' + cfg.colorIndex;

    var hex = {};
    (cfg.colorHex || '').split(/\n/).forEach(function (l) {
      var i = l.lastIndexOf(':'); if (i > 0) hex[l.slice(0, i).trim().toLowerCase()] = l.slice(i + 1).trim();
    });

    var variants = cfg.variants;
    var sizes = [], colors = [], colorImg = {};
    variants.forEach(function (v) {
      if (sizes.indexOf(v[sKey]) < 0) sizes.push(v[sKey]);
      if (colors.indexOf(v[cKey]) < 0) colors.push(v[cKey]);
      if (v.img && !colorImg[v[cKey]]) colorImg[v[cKey]] = v.img;
    });
    var order = (cfg.sizeOrder || []).map(function (s) { return String(s).trim().toUpperCase(); });
    sizes.sort(function (a, b) {
      var ia = order.indexOf(String(a).toUpperCase()), ib = order.indexOf(String(b).toUpperCase());
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });

    function find(size, color) {
      for (var i = 0; i < variants.length; i++) if (variants[i][sKey] === size && variants[i][cKey] === color) return variants[i];
      return null;
    }
    function shade(h, f) {
      var m = /^#?([0-9a-f]{6})$/i.exec(h || ''); if (!m) return '#555';
      var n = parseInt(m[1], 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
      r = Math.round(r * f); g = Math.round(g * f); b = Math.round(b * f);
      return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }
    // Silueta de tanga en SVG para colores sin foto (con estampado si el nombre lo indica)
    function silhouette(color) {
      var base = hex[String(color).toLowerCase()] || '#d9d4cc', lc = String(color).toLowerCase(), pat = '', fillPat = '';
      if (lc.indexOf('peca') > -1) { pat = '<pattern id="p" width="7" height="7" patternUnits="userSpaceOnUse"><circle cx="2" cy="2" r="1.1" fill="' + shade(base, .55) + '"/><circle cx="5.5" cy="5" r=".8" fill="' + shade(base, .6) + '"/></pattern>'; fillPat = 'url(#p)'; }
      else if (lc.indexOf('cebra') > -1 || lc.indexOf('zebra') > -1) { pat = '<pattern id="p" width="9" height="9" patternUnits="userSpaceOnUse" patternTransform="rotate(32)"><path d="M0 0h3.2v9H0z" fill="#3a2b22"/></pattern>'; fillPat = 'url(#p)'; }
      var shape = 'M9 34 Q50 25 91 34 L90 43 Q69 51 57 78 Q50 86 43 78 Q31 51 10 43 Z';
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs>' + pat + '</defs><rect width="100" height="100" fill="#fff"/>' +
        '<path d="' + shape + '" fill="' + base + '"/>' + (fillPat ? '<path d="' + shape + '" fill="' + fillPat + '"/>' : '') +
        '<path d="M10 34 Q50 26 90 34 L90 38 Q50 30 10 38 Z" fill="' + shade(base, .82) + '" opacity=".7"/></svg>';
      return 'url("data:image/svg+xml,' + encodeURIComponent(svg).replace(/'/g, '%27') + '")';
    }
    function bg(color) {
      if (colorImg[color]) return 'url("' + colorImg[color] + '")';
      return silhouette(color);
    }

    var state = { size: null, slots: [] };
    var $ = function (s) { return root.querySelector(s); };
    var elSizes = $('[data-sizes]'), elColors = $('[data-colors]'), elSlots = $('[data-slots]'),
        elProg = $('[data-progress]'), elBar = $('[data-bar]'), elMsg = $('[data-msg]'),
        btn = $('[data-add]'), btnLabel = $('[data-add-label]'), elName = $('[data-color-name]'),
        sticky = $('[data-sticky]'), stickyBtn = $('[data-sticky-btn]'), stickyProg = $('[data-sticky-progress]');
    elSlots.style.setProperty('--pack', N);

    function used(id) { return state.slots.filter(function (s) { return s.id === id; }).length; }
    function msg(text, isErr) {
      if (!text) { elMsg.hidden = true; return; }
      elMsg.hidden = false; elMsg.textContent = text; elMsg.classList.toggle('is-error', !!isErr);
    }

    function renderSizes() {
      elSizes.innerHTML = '';
      sizes.forEach(function (size) {
        var any = variants.some(function (v) { return v[sKey] === size && v.available; });
        if (!any) return; // sin stock: no se muestra
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'titta-size'; b.textContent = size;
        b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', state.size === size ? 'true' : 'false');
        b.disabled = !any;
        b.addEventListener('click', function () { state.size = size; msg(''); render(); });
        elSizes.appendChild(b);
      });
    }

    function renderColors() {
      elColors.innerHTML = '';
      colors.forEach(function (color) {
        var v = state.size ? find(state.size, color) : null;
        var anyAvail = variants.some(function (x) { return x[cKey] === color && x.available; });
        var ok = state.size ? (v && v.available && used(v.id) < v.stock) : anyAvail;
        if (!ok) return; // solo colores con stock
        var qty = state.slots.filter(function (s) { return s.color === color && (!state.size || s.size === state.size); }).length;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'titta-color' + (qty ? ' is-picked' : '');
        var g = bg(color);
        if (g.indexOf('url(') === 0) b.style.backgroundImage = g; else b.style.backgroundColor = g;
        b.disabled = !ok;
        b.title = color + (ok ? '' : ' · agotado' + (state.size ? ' en ' + state.size : ''));
        b.setAttribute('aria-label', 'Agregar color ' + color + (ok ? '' : ' (agotado)'));
        if (qty) { var q = document.createElement('span'); q.className = 'titta-color__qty'; q.textContent = '×' + qty; b.appendChild(q); }
        if (ok && v && v.stock - used(v.id) <= 3) { var lw = document.createElement('span'); lw.className = 'titta-color__low'; lw.textContent = 'Últimas'; b.appendChild(lw); b.title = color + ' · ¡últimas unidades en ' + state.size + '!'; }
        b.addEventListener('mouseenter', function () { elName.textContent = b.title; });
        b.addEventListener('focus', function () { elName.textContent = b.title; });
        b.addEventListener('click', function () { addColor(color); });
        elColors.appendChild(b);
      });
    }

    function addColor(color) {
      if (!state.size) {
        msg('Primero elige tu talla 👆', true);
        elSizes.classList.remove('is-shake'); void elSizes.offsetWidth; elSizes.classList.add('is-shake');
        return;
      }
      if (state.slots.length >= N) { msg('Ya elegiste tus ' + N + '. Quita una para cambiarla.', false); return; }
      var v = find(state.size, color);
      if (!v || !v.available || used(v.id) >= v.stock) return;
      state.slots.push({ id: v.id, size: state.size, color: color });
      elName.textContent = color + ' · talla ' + state.size + ' agregada';
      msg('');
      render();
    }

    function renderSlots() {
      elSlots.innerHTML = '';
      for (var i = 0; i < N; i++) {
        var li = document.createElement('li');
        var s = state.slots[i];
        li.className = 'titta-slot' + (s ? ' is-filled' : '');
        if (s) {
          var g = bg(s.color);
          if (g.indexOf('url(') === 0) li.style.backgroundImage = g; else li.style.backgroundColor = g;
          li.setAttribute('aria-label', 'Tanga ' + (i + 1) + ': ' + s.color + ' talla ' + s.size);
          li.innerHTML = '<span class="titta-slot__size">' + s.size + '</span>';
          var rm = document.createElement('button');
          rm.type = 'button'; rm.className = 'titta-slot__rm'; rm.innerHTML = '×';
          rm.setAttribute('aria-label', 'Quitar ' + s.color + ' talla ' + s.size);
          (function (idx) { rm.addEventListener('click', function () { state.slots.splice(idx, 1); msg(''); render(); }); })(i);
          li.appendChild(rm);
        } else {
          li.textContent = i + 1;
        }
        elSlots.appendChild(li);
      }
    }

    function renderCta() {
      var n = state.slots.length, left = N - n;
      elProg.textContent = n + ' de ' + N;
      elBar.style.width = (n / N * 100) + '%';
      if (stickyProg) stickyProg.textContent = n + ' de ' + N + ' elegidas';
      if (left === 0) {
        if (cfg.compare > cfg.price) msg('¡Pack completo! Ahorras ' + money(cfg.compare - cfg.price, cfg.moneyFormat) + ' y el envío es gratis 🎉', false);
        btn.disabled = false;
        btnLabel.textContent = 'Agregar mis ' + N + ' tangas · ' + money(cfg.price, cfg.moneyFormat);
        if (stickyBtn) stickyBtn.textContent = 'Agregar al carrito';
      } else {
        btn.disabled = true;
        btnLabel.textContent = !state.size ? 'Elige tu talla para empezar' : (left === 1 ? 'Elige 1 tanga más' : 'Elige ' + left + ' tangas más');
        if (stickyBtn) stickyBtn.textContent = !state.size ? 'Elegir talla' : 'Faltan ' + left;
      }
    }

    function render() { renderSizes(); renderColors(); renderSlots(); renderCta(); }

    // Elígelas por mí
    var rnd = $('[data-random]');
    if (rnd) rnd.addEventListener('click', function () {
      if (!state.size) { addColor(null); return; }
      var guard = 0;
      while (state.slots.length < N && guard++ < 200) {
        var pool = colors.filter(function (c) {
          var v = find(state.size, c);
          return v && v.available && used(v.id) < v.stock;
        });
        if (!pool.length) break;
        var fresh = pool.filter(function (c) { return !state.slots.some(function (s) { return s.color === c; }); });
        var list = fresh.length ? fresh : pool;
        addColor(list[Math.floor(Math.random() * list.length)]);
      }
      if (state.slots.length < N) msg('No hay suficientes colores disponibles en talla ' + state.size + '. Prueba otra talla para completar.', true);
    });

    // Agregar al carrito
    btn.addEventListener('click', function () {
      if (state.slots.length !== N) return;
      var qty = {};
      state.slots.forEach(function (s) { qty[s.id] = (qty[s.id] || 0) + 1; });
      var items = Object.keys(qty).map(function (id) { return { id: +id, quantity: qty[id] }; });
      btn.classList.add('is-loading'); btnLabel.textContent = 'Agregando…'; msg('');
      var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root_ + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          btn.classList.remove('is-loading');
          if (!res.ok) { msg(res.d.description || res.d.message || 'No pudimos agregar tu pack. Intenta de nuevo.', true); renderCta(); return; }
          state.slots = []; render();
          btnLabel.textContent = '¡Listo! Pack agregado';
          var product = res.d.items ? res.d.items[0] : res.d;
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: product, addToCartBtn: btn } }));
          if (window.theme && theme.settings && theme.settings.cartType === 'page') window.location.href = root_ + 'cart';
          setTimeout(renderCta, 2500);
        })
        .catch(function () { btn.classList.remove('is-loading'); msg('Error de conexión. Intenta de nuevo.', true); renderCta(); });
    });

    // Barra fija móvil
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        var e = en[0];
        var show = !e.isIntersecting && e.boundingClientRect.top > 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      io.observe(root);
      stickyBtn.addEventListener('click', function () {
        if (state.slots.length === N) { btn.click(); return; }
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // Guía de tallas
    var dlg = root.querySelector('[data-size-dialog]'), op = root.querySelector('[data-size-open]'), cl = root.querySelector('[data-size-close]');
    if (dlg && op) {
      op.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
      cl.addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }

    // Talla preseleccionada si solo hay una disponible
    var avail = sizes.filter(function (s) { return variants.some(function (v) { return v[sKey] === s && v.available; }); });
    if (avail.length === 1) state.size = avail[0];
    render();
  }

  /* ---------- Entrega express (fechas reales CO: días hábiles + festivos) ---------- */
  function initShip(el) {
    var CUTOFF = +el.dataset.cutoff || 15, DAYS = +el.dataset.days || 2;
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var iso = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
    var add = function (d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; };
    var nextMon = function (d) { var x = new Date(d); while (x.getDay() !== 1) x.setDate(x.getDate() + 1); return x; };
    function easter(y) { var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1; return new Date(y, mo - 1, da); }
    var cache = {};
    function hol(y) {
      if (cache[y]) return cache[y];
      var s = {}, a = function (d) { s[iso(d)] = 1; };
      [[0, 1], [4, 1], [6, 20], [7, 7], [11, 8], [11, 25]].forEach(function (p) { a(new Date(y, p[0], p[1])); });
      [[0, 6], [2, 19], [5, 29], [7, 15], [9, 12], [10, 1], [10, 11]].forEach(function (p) { a(nextMon(new Date(y, p[0], p[1]))); });
      var e = easter(y); a(add(e, -3)); a(add(e, -2)); a(nextMon(add(e, 39))); a(nextMon(add(e, 60))); a(nextMon(add(e, 68)));
      return (cache[y] = s);
    }
    var work = function (d) { return d.getDay() >= 1 && d.getDay() <= 5 && !hol(d.getFullYear())[iso(d)]; };
    var nextWork = function (d) { var x = new Date(d); while (!work(x)) x.setDate(x.getDate() + 1); return x; };
    var addWork = function (d, n) { var x = new Date(d), k = 0; while (k < n) { x.setDate(x.getDate() + 1); if (work(x)) k++; } return x; };
    var fmt = function (d) { return d.toLocaleDateString('es-CO', { weekday: 'long', day: 'numeric', month: 'long' }); };
    var fmtS = function (d) { return d.toLocaleDateString('es-CO', { weekday: 'short', day: 'numeric' }).replace('.', ''); };
    var q = function (s) { return el.querySelector(s); };

    function update() {
      var now = new Date(), today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var sameDay = work(today) && now.getHours() < CUTOFF;
      var ship = sameDay ? today : nextWork(add(today, 1));
      var eta = addWork(ship, DAYS);
      q('[data-ship-eta]').textContent = fmt(eta);
      q('[data-ship-d1]').textContent = sameDay ? 'Hoy mismo' : fmtS(ship);
      q('[data-ship-d2]').textContent = fmtS(eta);
      var t = q('[data-ship-timer]');
      if (sameDay) {
        var cut = new Date(now); cut.setHours(CUTOFF, 0, 0, 0);
        var mins = Math.max(0, Math.round((cut - now) / 60000)), h = Math.floor(mins / 60), m = mins % 60;
        t.innerHTML = '⚡ Pide en las próximas <strong>' + (h ? h + ' h ' : '') + m + ' min</strong> y lo despachamos <strong>hoy</strong>';
      } else {
        t.innerHTML = '⚡ Pide hoy y lo despachamos el <strong>' + fmt(ship) + '</strong>';
      }
      t.hidden = false;
    }
    update();
    setInterval(update, 30000);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) el.classList.add('is-in'); }); }, { threshold: .4 }).observe(el);
    } else el.classList.add('is-in');
  }

  function init(scope) {
    (scope || document).querySelectorAll('.titta-pack').forEach(function (sec) {
      if (sec.dataset.tpInit) return; sec.dataset.tpInit = '1';
      sec.querySelectorAll('[data-gal]').forEach(initGallery);
      sec.querySelectorAll('[data-builder]').forEach(initBuilder);
      sec.querySelectorAll('[data-ship]').forEach(initShip);
    });
  }

  /* Respaldo de Addi: si el widget no pinta en 8s mostramos el texto; si pinta después, lo ocultamos */
  (function () {
    var t0 = Date.now();
    var iv = setInterval(function () {
      var fbs = document.querySelectorAll('[data-addi-fallback]');
      if (!fbs.length) { clearInterval(iv); return; }
      var w = document.querySelector('addi-product-widget');
      var ok = w && w.getBoundingClientRect().height > 5;
      fbs.forEach(function (fb) { fb.hidden = ok || (Date.now() - t0 < 8000); });
      if (Date.now() - t0 > 30000) clearInterval(iv);
    }, 1000);
  })();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Titta · La app de videos de producto inserta su sección después del botón de compra: movemos SOLO el contenedor de la sección (no sus piezas internas) debajo de los métodos de pago */
(function () {
  function relocate() {
    document.querySelectorAll('.titta-buy__row, .titta-buy, .titta-pack .titta-builder').forEach(function (parent) {
      Array.prototype.slice.call(parent.children).forEach(function (v) {
        var cls = String(v.className || '');
        if (cls.indexOf('section-template--') !== 0 || cls.indexOf('ss_product_vid') < 0 || cls.indexOf('-settings') > -1) return;
        var blk = v.closest('.titta-buy, .titta-builder'); if (!blk) return;
        var anchor = blk.querySelector(':scope > .titta-builder__below') || blk.querySelector(':scope > .titta-pay');
        if (anchor && anchor.nextElementSibling !== v) { anchor.after(v); v.classList.add('titta-videos-moved'); }
      });
    });
  }
  var n = 0, iv = setInterval(function () { relocate(); if (++n > 20) clearInterval(iv); }, 500);
  document.addEventListener('DOMContentLoaded', relocate);
})();
